import React, { Component } from "react";
import InputRow from "./InputRow";
import { handleAlphabetCheck, handleNumberCheck } from "../constants";
import PropTypes from "prop-types";

export default class Parent2 extends Component {
  render() {
    return (
      <div>
        <div>
          <InputRow
            name="select"
            data={this.props.relationshipData}
            required={"*"}
            errMsg={this.props.errRelation}
            value={this.props.relationship}
            onChange={(e) => this.props.relationshipUpdate(e)}
            rowName="Relationship with You"
            disabled={this.props.disabled}
            hover="Tell us how the person is related to you."
          />

          <InputRow
            name="text"
            rowName="First Name"
            required={"*"}
            errMsg={this.props.errFName}
            value={this.props.fName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeFName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
          />

          <InputRow
            name="text"
            rowName="Maiden Name"
            required={"*"}
            errMsg={this.props.errLName}
            value={this.props.lName}
            onChange={(e) => {
              if (handleAlphabetCheck(e) === 1 || e === "") {
                this.props.onChangeLName(e);
              } else {
                alert("Please Enter Alphabets only!");
              }
            }}
            disabled={this.props.disableAll}
          />

          <InputRow
            name="text"
            rowName="Mobile Number"
            required={"*"}
            errMsg={this.props.errMobile}
            value={this.props.mobileNumber}
            onChange={(e) => {
              if (handleNumberCheck(e) === 0) {
                this.props.onChangeNumber(e);
              } else {
                alert("Enter Numbers only!");
              }
            }}
            disabled={this.props.disableAll}
            hover={
              this.props.guardian
                ? "Insert the contact number of your guardian."
                : "Insert the contact number of your parent."
            }
          />

          <InputRow
            name="email"
            rowName="E-mail Address"
            required={
              this.props.guardian || this.props.relationship == 4 ? "*" : ""
            }
            value={this.props.email}
            onChange={(val) => this.props.onChangeEmail(val)}
            errMsg={this.props.errEmail}
            hover={
              this.props.guardian
                ? "Insert the email address of your guardian."
                : "Insert the email address of your parent."
            }
          />

          <InputRow
            name="text"
            rowName="Profession"
            required={""}
            errMsg={this.props.errProfession}
            value={this.props.profession}
            onChange={(e) => {
              this.props.onChangeProfession(e);
            }}
            disabled={this.props.disableAll}
            hover={
              this.props.guardian
                ? "Insert the current job held by your guardian. (For data collection and analysis purposes only. This will not effect your application.)"
                : "Insert the current job held by your parent. (For data collection and analysis purposes only. This will not effect your application.)"
            }
          />

          <InputRow
            name="text"
            rowName="Institution"
            required={""}
            errMsg={this.props.errProfession}
            value={this.props.company}
            onChange={(e) => {
              this.props.onChangeCompany(e);
            }}
            disabled={this.props.disableAll}
            hover={
              this.props.guardian
                ? "Insert the current institution your guardian is working in. (For data collection and analysis purposes only. This will not effect your application.)"
                : "Insert the current institution your parent is working in. (For data collection and analysis purposes only. This will not effect your application.)"
            }
          />
        </div>
      </div>
    );
  }
}

Parent2.propTypes = {
  relationshipData: PropTypes.array.isRequired,
  relationship: PropTypes.number.isRequired,
  relationshipUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  disableAll: PropTypes.bool,
  onChangeCompany: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onChangeFName: PropTypes.func.isRequired,
  onChangeNumber: PropTypes.func.isRequired,
  onChangeProfession: PropTypes.func.isRequired,
  fName: PropTypes.string.isRequired,
  profession: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  errEmail: PropTypes.string,
  errRelation: PropTypes.string,
  errFName: PropTypes.string,
  errProfession: PropTypes.string,
  errMobile: PropTypes.string,
  guardian: PropTypes.bool,
};
